import React, { useState } from 'react';

export const ProductTabsContext = React.createContext();

export default ({ children }) => {
  const [linkedVehiclesTab, setLinkedVehiclesTab] = useState(null);
  const [partsListTab, setPartsListTab] = useState(null);
  const [referencesListTab, setReferencesListTab] = useState(null);

  return (
    <ProductTabsContext.Provider
      value={{
        linkedVehiclesTab,
        partsListTab,
        setLinkedVehiclesTab,
        setPartsListTab,
        referencesListTab,
        setReferencesListTab,
      }}
    >
      {children}
    </ProductTabsContext.Provider>
  );
};



// WEBPACK FOOTER //
// ./src/context/ProductTabsContext.js